import { atom } from 'jotai';

export const globalOptiHeaderVisibleAtom = atom<boolean>(true);
